import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Close } from "../icons";
import Input from "../common/Input";

export default function AllotmentModal({
  open,
  onClose,
  onSubmit,
  itemData = {},
  isLoading = false,
}) {
  const [formData, setFormData] = useState({
    quantity: "",
    purpose: "",
  });

  useEffect(() => {
    if (open) {
      setFormData({ quantity: "", purpose: "" });
    }
  }, [open]);

  function handleSubmit() {
    onSubmit?.({
      campusItemId: itemData.campusItemId,
      stockAlloted: Number(formData.quantity),
      comment: formData.purpose,
    });
  }

  const remainingBalance = Math.max(
    0,
    (parseInt(itemData.stock) || 0) - (parseInt(formData.quantity) || 0),
  );
  const targetBalance = remainingBalance;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="max-w-[416px] pt-8 pb-10 px-0"
      centered={false}
    >
      <div className="w-full">
        <div className="pl-7 pr-11 pb-2.5">
          <div className="flex items-center justify-between">
            <p className="text-xl leading-6 font-bold text-black">
              Post Allotment
            </p>

            <button onClick={onClose} aria-label="close">
              <Close />
            </button>
          </div>
          <p className="text-sm leading-6 text-black ">{itemData.name}</p>
        </div>

        <div className="border-t border-[#E5E5E5] pt-6 pl-8 pr-9">
          {/* Available Balance */}
          <div className="bg-[#F2F2F2] rounded-[5px] p-2.5 flex justify-between items-center">
            <span className="text-[#A2A1A8] text-sm leading-6 font-medium">
              Available Balance
            </span>
            <span className="text-black leading-6 text-sm">
              {itemData.stock || 0} Units
            </span>
          </div>

          {/* Quantity to Allot */}
          <div className="pt-[14px]">
            <Input
              type="number"
              label="Quantity to Allot"
              min="0"
              max={itemData.stock || 0}
              value={formData.quantity}
              onChange={(e) => {
                let val = e.target.value;
                if (val !== "" && Number(val) < 0) {
                  val = "0";
                }
                // Optional: Clamp to max stock
                if (val !== "" && Number(val) > (itemData.stock || 0)) {
                  val = (itemData.stock || 0).toString();
                }
                setFormData({ ...formData, quantity: val });
              }}
              placeholder="Enter Quantity"
            />
          </div>

          {/* Purpose / Comment */}
          <div className="pt-2.5">
           
            <Input
             label=" Purpose / Comment"
             type="text"
              value={formData.purpose}
              onChange={(e) =>
                setFormData({ ...formData, purpose: e.target.value })
              }
              placeholder="Briefly describe the allotment purpose"
            
            />
          </div>

          {/* Remaining and Target Balance */}
          <div className="mt-5 grid grid-cols-2 gap-4">
            <div className="">
              <p className="text-[#828282] text-sm leading-6">Remaining</p>
              <p className="text-black leading-6 text-sm">{remainingBalance}</p>
            </div>
            <div className="">
              <p className="text-[#828282] text-sm leading-6">Target Balance</p>
              <p className="text-[#EE1515]  text-sm leading-6">
                {targetBalance > 0 ? `-${targetBalance}` : targetBalance}
              </p>
            </div>
          </div>

          {/* Confirm Button */}
          <button
            onClick={handleSubmit}
            disabled={isLoading || !formData.quantity || !formData.purpose.trim()}
            className="w-full bg-[#6D4E8A] text-white py-3 font-bold text-sm rounded-[5px] hover:bg-[#5a3f75] transition mt-5 disabled:opacity-70"
          >
            {isLoading ? "Processing..." : "Confirm Allotment"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
